export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5185.8a0df0a9.jpg";